
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/language";
import { BarChart3 } from "lucide-react";
import { t } from "@/utils/translations";

const GrowthStatisticsCard = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  
  return (
    <div className="max-w-4xl mx-auto px-4">
      <div className="glass-card rounded-xl p-8 mt-8 bg-accent/10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-2xl font-bold mb-4">{t('premium.growthStatistics', language)}</h2>
            <p className="text-muted-foreground mb-6">
              {t('premium.growthStatisticsDescription', language)}
            </p>
            <Button onClick={() => navigate('/statistics')}>
              <BarChart3 className="mr-2 h-4 w-4" />
              {t('premium.viewSampleStatistics', language)}
            </Button>
          </div>
          <div className="flex justify-center">
            <div className="aspect-video w-full max-w-md rounded-lg bg-background/80 border flex items-center justify-center">
              <BarChart3 className="h-24 w-24 text-primary/40" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrowthStatisticsCard;
